import { Button, Card, Typography } from "antd";
import { useNavigate } from "react-router";

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="content_page">
      <Card
        title="Página não encontrada!"
        styles={{
          header: {
            color: "#0899d1",
            fontWeight: 600,
          },
        }}
      >
        <p>Não foi possível encontrar a página ou recurso solicitado.</p>
        <p>Verifique a URL e tente novamente.</p>

        <Button onClick={() => navigate("/")}>Ir para o início</Button>
      </Card>
    </div>
  );
}
